import { Box, Typography } from "@mui/material"
import { ChangeEvent, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"

import { AmountInputProps } from "./props"
import {
  Container,
  CurrencyBoxStyle,
  CurrencySign,
  CurrencySignContainer,
  CurrencySignSpace,
  LimitsButton,
  TextFieldStyled,
  TextFieldWithCurrencyBox,
} from "./styled"
import { AMOUNT_ERROR, validateAmount } from "./utils/utils"
import { ROUTES_PATHS, RUBLE } from "../../utils/constants"
import { resetSteps } from "../../store/slices/routingSlice/routingSlice"
import { colors } from "../../theme/colors"

const AmountInput = ({
  limit,
  balance,
  label,
  marginTop,
  marginBottom,
  onChange,
  value,
  currency,
  helperText,
  currencyBox,
  ...rest
}: AmountInputProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [error, setError] = useState<{ result: boolean; reason: string }>({
    result: false,
    reason: "",
  })
  const handleChange = (
    evt: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    if (onChange) {
      onChange(evt)
    }
  }

  const getHelperText = () => {
    switch (error.reason) {
      case "limit":
        return (
          <>
            <Typography variant="h7Pale" color="error">
              {AMOUNT_ERROR}
              {limit}
              {RUBLE}. Проверьте свои
            </Typography>
            <LimitsButton
              color="error"
              onClick={() => {
                dispatch(resetSteps())
                navigate(`/${ROUTES_PATHS.limits}`)
              }}
            >
              лимиты
            </LimitsButton>
          </>
        )
      case "balance":
        return (
          <Typography variant="h7Pale" color="error">
            Недостаточно средств. Уменьшите сумму или пополните баланс
          </Typography>
        )
      default:
        return <Typography variant="h7Pale">{helperText}</Typography>
    }
  }

  useEffect(() => {
    if (!value) {
      setError({ result: false, reason: "" })
      return
    }
    const validate = validateAmount(value, limit, balance)
    if (validate.result) {
      setError(validate)
      return
    }
    setError({ result: false, reason: "" })
  }, [value])

  return (
    <Container marginTop={marginTop} marginBottom={marginBottom}>
      {label && <Typography variant="h4Bold">{label}</Typography>}
      <Box sx={TextFieldWithCurrencyBox}>
        <TextFieldStyled
          fullWidth
          value={value}
          {...rest}
          onChange={handleChange}
          error={error.result}
          helperText={getHelperText()}
        />
        {currencyBox && (
          <Box sx={CurrencyBoxStyle}>
            <Typography color={colors.darkGrey}>{RUBLE}</Typography>
          </Box>
        )}
      </Box>

      <CurrencySignContainer>
        <CurrencySignSpace>
          <Typography>{value}</Typography>
        </CurrencySignSpace>
        {value && <CurrencySign>{currency}</CurrencySign>}
      </CurrencySignContainer>
    </Container>
  )
}

export default AmountInput
